import { LocationOnOutlined } from "@mui/icons-material";
import {
  Autocomplete,
  CircularProgress,
  InputAdornment,
  TextField,
} from "@mui/material";
import { DELIVERY_KEY, DELIVERY_KEY_LIVE } from "lib/global";
import { serverPost } from "lib/serverRequest";
import { addressDetailInfo } from "models/third/addressRight";
import { addressRightGetAutoComplete } from "models/third/addressRight";
import React, { useEffect, useState } from "react";
import { openLoading } from "store/reducers/tools";

export default function AddressPicker({
  onChange = () => {},
  label = "",
  name = "",
  placeholder = "",
  value = null,
  size = "medium",
  ...props
}) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");
  const [text, setText] = useState("");
  const loading = open && options.length === 0 && text.length >= 3;

  const handleText = (e) => setText(e?.target?.value ?? "");

  useEffect(() => {
    let active = true;

    // if (!loading) {
    //   return undefined;
    // }

    (async () => {
      const newOptions = await addressRightGetAutoComplete({ term: text });

      if (active) {
        setOptions(newOptions);
      }
    })();

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, text]);

  const handleChange = async (e, v) => {
    if (!v) {
      onChange(e, v);
      return;
    }
    openLoading(true);
    const addressDetail = await addressDetailInfo(v?.id ?? "");
    if (addressDetail?.structured_address?.postcode === "1081") {
      setHelperText(
        "Sorry, this address is not available for overnight delivery!"
      );
      setError(true);
      return;
    }
    let url = `${DELIVERY_KEY}/v1/services?lat=${addressDetail?.location?.wgs84_lat}&lon=${addressDetail?.location?.wgs84_lon}&carrierName=PostHaste`;
    if (addressDetail?.structured_address?.postcode * 1 < 7000) {
      url = `${DELIVERY_KEY_LIVE}/v1/services?lat=${addressDetail?.location?.wgs84_lat}&lon=${addressDetail?.location?.wgs84_lon}&carrierName=NZCouriers`;
    }
    serverPost({
      url: "freightways/service",
      data: {
        url: url,
        method: "get",
        postCode: addressDetail?.structured_address?.postcode * 1 ?? "",
      },
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) return;
        if (res?.["services"]?.[0]?.nonUrban) {
          setHelperText(
            "Sorry, this address is not available for overnight delivery!"
          );
          setError(true);
          return;
        }
        setError(false);
        setHelperText("");
        onChange(e, {
          ...v,
          region: addressDetail?.["structured_address"]?.region ?? "",
          postcode: addressDetail?.["structured_address"]?.postcode ?? "",
        });
      },
    });
  };

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
    <Autocomplete
      name={name}
      open={open}
      disableClearable
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      isOptionEqualToValue={(option, value) => option.label === value.label}
      getOptionLabel={(option) => option.label ?? ""}
      options={options}
      loading={loading}
      value={value ?? null}
      onChange={handleChange}
      size={size}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          label={label}
          value={text}
          onChange={handleText}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
            startAdornment: (
              <InputAdornment position="start">
                <LocationOnOutlined fontSize="large" color="secondary" />
              </InputAdornment>
            ),
          }}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
}
